import type { Display } from '@teachino/shared-util';
import { h, ref, shallowRef } from 'vue';
import { Modal } from './modal';

const displayRef = shallowRef<Display | null>(null);
const isOpen = ref(false);

/**
 * @deprecated use the Modal class instead
 */
export function useModal() {
  const modal = new Modal();
  function open(display: Display): Promise<void> {
    modal.open(
      h(display.component, {
        ...display,
      }),
    );

    let resolveOnClosePromise: null | (() => void) = null;
    const onClosePromise = new Promise<void>(
      (resolve) => (resolveOnClosePromise = resolve),
    );
    modal.onClose(() => resolveOnClosePromise?.());
    displayRef.value = display;
    isOpen.value = true;
    return onClosePromise;
  }
  function close(): void {
    Modal.closeAll();
  }
  return {
    open,
    close,
  };
}
